'use client';
import React, { FC, useEffect, useState } from 'react';
import { TypeFooter, TypeSubFooter } from '@/core/generated-types';
import { FooterLegal } from '../FooterLegal';
import FooterSections from './FooterSections';
import { isSubflowPathname } from '../Header/utils';
import { usePathname } from '@/navigation';
import { useIsDesktop } from '@/hooks/useIsDesktop';

interface FooterProps {
  footer: TypeFooter;
  footerLegal: TypeSubFooter;
}

const Footer: FC<FooterProps> = ({ footer, footerLegal }) => {
  const pathname = usePathname();
  const showSimpleNav = !useIsDesktop();
  const [isSimpleNavType, setIsSimpleNavType] = useState(false);

  useEffect(() => {
    setIsSimpleNavType(Boolean(showSimpleNav && isSubflowPathname(pathname)));
  }, [showSimpleNav]);

  const { footerSections } = footer?.fields || {};
  return (
    <footer data-testid="le-footer">
      {footerSections && !isSimpleNavType && (
        <FooterSections footerSections={footerSections} />
      )}
      {footerLegal?.fields && <FooterLegal {...footerLegal} />}
    </footer>
  );
};

export default React.memo(Footer);
